<template>
    <div style="background: #f6f6f6; padding: 20px 50px;">
        <div class="close-icon cursor-pointer" style="position: absolute; right: 20px;" @click="closeConfirmModal">X</div>
        <img src="../../../../assets/img/logo.svg" alt="log" height="40" />
        <hr />
        <div class="d-flex flex-column justify-content-end align-items-end">
            <p class="m-0">Status of the recommandation</p>
            <div class="py-2 px-4 mt-1" style="border: solid 1px #ddd; border-radius: 2px">
                <b style="color: #17a2b8;">Investment</b>
            </div>
        </div>
        <div class="mt-3">
            <h1 style="color: #17a2b8; font-size: 22px;">Congratulations!</h1>
            <p>We are happy to learn that the negotiation with the company {{ company && company.company_name }} based in {{ company && company.country }} was a success. </p>
        </div>

        <div style="background: #fff;">
            <div class="d-flex justify-content-start align-items-center py-3 px-5" style="background: #caebf2; color: #000;">
                <b class="m-0">Deal {{ myCompany.id }} - Company {{ company && company.company_name }}</b>
            </div>

            <div class="p-3">
                <div class="d-flex flex-column flex-sm-row justify-content-start align-items-center align-items-md-start" style="padding: 0px 20px 0 20px; gap: 30px;">
                    <div style="max-height: 160px; max-width: 160px;">
                        <img
                            :src="baseUrl + myCompany.company.logo"
                            alt="Company logo"
                            height="140"
                            @error="handleImageError"
                        />
                    </div>
                    <div class="text-left">
                        <p><b>Legal representative:</b> {{ company && company.gender }} {{ company && company.first_name }} {{ company && company.last_name }}</p>
                        <p>
                            <span style="display: inline-block; vertical-align: top; margin-right: 10px;"><b>HQ Address:</b></span>
                            <span style="display: inline-block; vertical-align: top;" v-if="company">
                                {{ company.street }}<br>
                                {{ company.zip }}, {{ company.city }} <br>
                                {{ company.country }}
                            </span>
                        </p>
                        <p><b>Phone:</b> {{ company && company.phone }}</p>
                        <p><b>Date of incorporation:</b> {{ company &&  formatDate(company.date_incorporation, personal?.city == 'United States') }}</p>
                        <p v-if="link.website"><b>Company website:  </b>
                            <a :href="link.website" target="_tab">{{ link.website }}</a>
                        </p>
                    </div>
                </div>

                <div class="text-left">
                    <p class="label m-0"><b>Descrription of the company</b></p>
                    <p class="border p-2" style="border-radius: 4px">
                        {{ resume && resume.resume }}
                    </p>

                    <p class="label m-0"><b>How much does the company want to raise ?</b></p>
                    <p class="border p-2" style="border-radius: 4px">{{ fund_raising ? fund_raising : "---" }}</p>
                </div>

                <div>
                    <div class="d-flex flex-column flex-sm-row justify-content-center justify-content-md-between align-items-center py-3 px-5" style="background: #caebf2; color: #000;">
                        <b class="m-0">{{ me && me.first_name }} {{ me && me.last_name }}</b>
                        <p class="m-0"><b>Country: </b>{{ personal && personal.city }}</p>
                    </div>

                    <div class="text-left mt-5">
                        <p class="label">
                            <b>Please enter the information about your investment</b>
                        </p>
                        <div class="d-flex flex-column flex-sm-row" style="">
                            <div class="col-12 col-sm-5 col-md-3">
                                <p class="m-0">Date of the deal <span class="text-danger">*</span></p>
                                <input
                                    type="date"
                                    class="form-control w-100 outline-none"
                                    :class="!dateInvestment && 'is-invalid'"
                                    style="border-radius: 4px; padding: 6px; outline: none"
                                    v-model="dateInvestment"
                                    :disabled="isSuccess"
                                />
                            </div>
                            <div class="col-12 col-sm-5 col-md-3">
                                <p class="m-0">Amount of the investment <span class="text-danger">*</span></p>
                                <div style="position: relative; width: 100%;">
                                    <span
                                        style="
                                            position: absolute;
                                            top: 50%;
                                            left: 10px;
                                            transform: translateY(-50%);
                                            color: #6c757d;
                                        "
                                    >
                                        $
                                    </span>
                                    <input
                                        type="text"
                                        placeholder="Enter amount"
                                        class="form-control w-100 outline-none"
                                        :class="!amount && 'is-invalid'"
                                        style="
                                            padding-left: 25px;
                                            border-radius: 4px;
                                            outline: none;
                                        "
                                        v-model="amount"
                                        @input="amount  = formatToString(amount)"
                                        @keypress="isNumber($event)"
                                        :disabled="isSuccess"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="text-left mt-5">
                        <p class="label">
                            <b>Please confirm the amount of your investment</b>
                        </p>
                        <div class="d-flex flex-column flex-sm-row" style="gap: 5px">
                            <div class="col-12 col-sm-5 col-md-3 d-none d-sm-block"></div>
                            <div class="col-12 col-sm-5 col-md-3">
                                <p class="m-0">Amount of the investment <span class="text-danger">*</span></p>
                                <div style="position: relative; width: 100%;">
                                    <span
                                        style="
                                            position: absolute;
                                            top: 50%;
                                            left: 10px;
                                            transform: translateY(-50%);
                                            color: #6c757d;
                                        "
                                    >
                                        $
                                    </span>
                                    <input
                                        type="text"
                                        placeholder="Confirm amount"
                                        class="form-control w-100 outline-none"
                                        :class="(!confirmAmount || amountDoesntMatch) && 'is-invalid'"
                                        style="
                                            padding-left: 25px;
                                            border-radius: 4px;
                                            outline: none;
                                        "
                                        v-model="confirmAmount"
                                        @input="confirmAmount  = formatToString(confirmAmount), amountDoesntMatch = false"
                                        @keypress="isNumber($event)"
                                        :disabled="isSuccess"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <button
                        class="btn btn-primary-site-color mt-3 py-3 px-5"
                        @click="redirectToInvestmentPage"
                        v-if="isSuccess"
                    >Investments</button>

                    <div class="d-flex justify-content-center align-items-center mt-8" style="gap: 25px" v-if="!isSuccess">
                        <button class="btn btn-outline-secondary" style="padding: 12px 25px;" @click="closeConfirmModal">Cancel</button>
                        <button
                            class="btn btn-primary-site-color"
                            :class="(!dateInvestment || !amount || !confirmAmount) && 'disabled'"
                            :disabled="!dateInvestment || !amount || !confirmAmount" style="padding: 12px 25px;"
                            @click="SaveDealIvestment"
                            v-if="!loader"
                        >Confirm</button>
                        <button class="btn btn-primary-site-color" style="padding: 12px 25px;" type="button" disabled v-else>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            Loading...
                        </button>
                    </div>

                    <div class="m-5 border p-3 alert alert-success text-start" v-if="isSuccess">
                        <p>
                            Your deal #{{ myCompany.id }} in your portfolio of IdeasFundX is now closed with the status <b>“Investment”</b>.
                        </p>
                        <p class="m-0">A confirmation email has been sent to you and the company <b>{{ myCompany?.company?.company_name }}</b>.</p>
                    </div>

                    <div class="py-5 px-10 m-5 text-start d-none" style="background: #caebf2; color: #000; gap: 200px">
                        <p class="">Your deal #{{ myCompany.id }} in your portfolio of IdeasFundX is now closed with the status “Investment”.</p>
                        <p class="m-0">A confirmation email has been sent to you and the company <b>{{ myCompany?.company?.company_name }}</b>..</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Company from '@/store/services/company/company.service.js'
    import CompanyService from "@/store/services/company/company.service";
    import Deal from "@/store/services/deal/deal.service";
    import NeedService from "@/store/services/need.service";
    import Profile from "@/store/services/profile-service";
    import { myMixins } from "@/mixins/mixins.js";

    export default {
        mixins: [myMixins],
        props: {
            companyId: Number,
            dealId: Number,
            myCompany: Object,
            closeConfirmModal: Function,
            getAllCompaniesDeals: Function,
        },
        data() {
            return {
                company: null,
                resume: null,
                fund_raising: null,
                personal: null,
                me: null,
                baseUrl: "",
                amount: null,
                confirmAmount: null,
                amountDoesntMatch: false,
                dateInvestment: this.formatInputDate(new Date()),
                loader: false,
                isSuccess: false,
                link: {}
            }
        },
        methods: {
            formatInputDate (date) {
                let dat = new Date(date);
                let year = dat.getFullYear();
                let month = dat.getMonth() + 1;
                let day = dat.getDate();
                if(day < 10 && month < 10){
                    return `${year}-0${month}-0${day}`;
                }
                else if (month < 10) {
                    return `${year}-0${month}-${day}`;
                }
                else{
                    return `${year}-${month}-${day}`;
                }
            },
            SaveDealIvestment () {
                this.loader = true;

                if (!this.dateInvestment) {
                    this.$toast.open({
                        message: 'Please select the date',
                        type: 'error',
                        position: 'top-right',
                        duration: 3000
                    });
                    this.loader = false;
                } else if (!this.amount) {
                    this.$toast.open({
                        message: 'Please enter the amount of the investment',
                        type: 'error',
                        position: 'top-right',
                        duration: 3000
                    });
                    this.loader = false;
                } else if (this.amount !== this.confirmAmount) {
                    this.$toast.open({
                        message: 'You must confirm the same investment amount.',
                        type: 'error',
                        position: 'top-right',
                        duration: 3000,
                        class: 'mobile-toast-center'
                    });
                    this.amountDoesntMatch = true;
                    this.loader = false;
                } else {
                    let data = {
                        company_id: this.companyId,
                        date_investment: this.dateInvestment,
                        investment_amount: this.formatToInt(this.amount)
                    }

                    Deal.saveDealInvestment(data, this.myCompany.id).then((res) => {
                        if (res.status === 201) {
                            this.$toast.open({
                                message: res.data.message,
                                type: 'success',
                                position: 'top-right',
                                duration: 40000,
                                class: 'mobile-toast-center'
                            });
                            Company.updateToHighStatus({deal_status: 'Investment'}, this.dealId)
                            this.getAllCompaniesDeals()
                            this.loader    = false;
                            this.isSuccess = true;
                        }
                    })
                }
            },
            redirectToInvestmentPage () {
                this.$store.commit("UPDATE_PAGE", 'investments');
            }
        },
        mounted() {
            console.log("====", this.myCompany)

            CompanyService.getDescribeById(this.companyId).then((res) => { 
                this.company = res.data; console.log(this.company) })
            CompanyService.getLink(this.companyId).then((res) => { this.link = res.data; }),
            CompanyService.getResume(this.companyId).then((res) => { this.resume = res.data; })
            NeedService.getFund(this.companyId).then((res) => {
            if (res.data) { this.fund_raising = res.data.raising.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","); }})
            Profile.myDetails().then((res) => { this.personal = res.data; })
            Profile.get().then((res) => { this.me = res.data; })
        },
        created() {
            this.baseUrl = window.location.protocol + '//' + window.location.host + '/storage/';
        }
    }
</script>

<style>
    p {
        font-weight: 400;
    }
    .btn-primary-site-color {
        background-color: #00b3cc !important;
        color: #fff !important;
    }
    .btn-primary-site-color:hover {
        background-color: transparent !important;
        border: solid 1px #00b3cc !important;
        color: #00b3cc !important;
    }
    .disabled {
        cursor: not-allowed !important;
    }
    @media (max-width: 768px) {
        .v-toast {
            top: 35% !important;
            left: 50% !important;
            transform: translate(-47%, -48%) !important;
            position: fixed !important;
            z-index: 9999;
            width: 85% !important;
        }
    }
</style>